module.exports = __webpack_public_path__ + "static/img/channel-3-1.e2d508be.png";